import { render, staticRenderFns } from "./volume-control.vue?vue&type=template&id=167d9f7a"
import script from "./volume-control.vue?vue&type=script&lang=js"
export * from "./volume-control.vue?vue&type=script&lang=js"
import style0 from "./volume-control.vue?vue&type=style&index=0&id=167d9f7a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports